import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import JobNotification from "./jobNotification";
import DownloadApp from "./downloadApp";
import CardsectionCurrentAffair from "./cardsectionCurrentAffair";
import SingleCurrentAffairPage from "./SingleCurrentAffairPage";
import { useParams } from "react-router-dom";
import { getSingleCurrentAffairs } from "../../service/services";

const useStyles = makeStyles((theme) => ({
  pageheadingmain: {
    width: "100%",

    [theme.breakpoints.down("sm")]: {
      position: "unset",
      padding: 0,
    },
  },
  pageheadingmaininner: {
    margin: "0 auto",
    paddingBottom: "1.5rem",
    paddingTop: "1rem",
    // backgroundImage: `url(${PageHeadingBg})`,
    backgroundRepeat: "no-repeat",
    position: "relative",
    backgroundSize: "cover",
    [theme.breakpoints.down("xs")]: {
      padding: "1rem 1rem 1.5rem 1rem",
    },
  },
  container: {
    maxWidth: "1250px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .MuiTypography-h6": {
      fontFamily: "'Playfair Display', serif !important",
      color: "#212121",
      fontSize: "1rem",
    },
    "& .MuiTypography-h2": {
      fontFamily: "'Playfair Display', serif !important",
      color: "#212121",
      fontSize: "1.5625rem",
      fontWeight: "600",
      [theme.breakpoints.down("sm")]: {
        marginBottom: 6,
      },
    },
    "& .MuiBreadcrumbs-ol": {
      fontFamily: "'Playfair Display', serif !important",
      [theme.breakpoints.down("sm")]: {
        padding: "0px",
        fontSize: 16,
        fontFamily: "'Playfair Display', serif !important",
        fontWeight: " 400 !important",
      },
    },
    "& .MuiTypography-colorInherit": {
      color: "#000",
      fontFamily: "'Playfair Display', serif !important",
      fontWeight: "600",
      fontSize: "0.75rem",
      [theme.breakpoints.down("sm")]: {
        padding: "0px",
        fontSize: 16,
        fontFamily: "'Playfair Display', serif !important",
        fontWeight: " 400 !important",
      },
    },
    "& .MuiTypography-colorTextPrimary": {
      color: "#FF8F12",
      fontFamily: "'Playfair Display', serif !important",
      fontWeight: "600",
      fontSize: "0.75rem",
    },
  },
  pageheading: {
    padding: "1rem 0 2rem 0",
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 0",
    },
  },
  pageheadhr: {
    margin: "0",
    width: "6rem",
    backgroundImage: "linear-gradient(90deg, #FF8008 0%, #FFC837 100%)",
    border: "0",
    height: " 0.1875rem",
  },
  quizzcontentcontainer: {
    maxWidth: "1250px",
    margin: "0 auto",
    marginTop: "20px",
    marginBottom: "15rem",
    display: "flex",
    justifyContent: "space-between",
  },
  heading: {
    fontSize: "3.8rem",
    fontFamily: "'Playfair Display', serif !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.8rem",
      fontFamily: "'Playfair Display', serif !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.6rem",
      fontFamily: "'Playfair Display', serif !important",
    },
  },
  w25: {
    width: "24%",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  w74: {
    width: "74%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      margin: "0rem 1rem",
    },
  },
}));

const AdmitCard = ({ Notification1, value, setValue }) => {
  const classes = useStyles();
  const { id } = useParams();

  // const matchedItem = Notification1.find((item) => item.id === value);
  // const currentAffairs = matchedItem?.current_cffairs || [];

  const currentAffairs = (
    value
      ? Notification1.find((item) => item.id === value)?.current_cffairs || []
      : Notification1.flatMap((item) => item.current_cffairs || [])
  ).sort((a, b) => new Date(b.created) - new Date(a.created));

  const currentAffairsLatest = [...currentAffairs].sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  const singleCurrentAffair = id
    ? currentAffairsLatest.find((item) => item.id === Number(id))
    : null;

  return (
    <>
      <div className={classes.quizzcontentcontainer}>
        <div className={classes.w25}>
          <JobNotification
            Notification={Notification1}
            value={value}
            setValue={setValue}
            id={id}
          />
          <DownloadApp />

          {/* <QuiklinksNotification /> */}
          {/* <DownloadApp /> */}
        </div>
        <div className={classes.w74}>
        {id ? (
          singleCurrentAffair ? (
            <SingleCurrentAffairPage Notification1={singleCurrentAffair} />
          ) : (
            <p>Current affair not found.</p>
          )
        ) : (
          currentAffairsLatest.map((data, index) => (
            <CardsectionCurrentAffair key={index} Notification1={data} />
          ))
        )}
      </div>
      </div>
    </>
  );
};
export default AdmitCard;
